import React, {ReactElement, useEffect, useState} from 'react';
import RupeesIcon from '../../../assets/images/rupees.svg';
import {useAppSelector} from '../../../redux/hooks';
import RupeesIconBlue from '../../../assets/images/rupee_blue.svg';
import {OrderResponse} from '../../../lib/order-types';
import {getMetadata, getUser} from '../../../core/localstorage-data';
import {lmrCheckedData} from '../../../redux/orderSlice';

type OrderCardProps = {
  type?: string;
  onDelete?: () => void;
  orderResp: OrderResponse;
};
const OrderCard: React.FC<OrderCardProps> = ({
  type,
  onDelete,
  orderResp,
}: OrderCardProps): ReactElement => {
  let BAG_PRICE = 0;
  const metaData = getMetadata();
  const customerProfileData = getUser();
  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );
  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }
  const lmrChecked = useAppSelector(lmrCheckedData);
  function renderOrderCard() {
    return (
      orderResp &&
      orderResp.itemList &&
      orderResp.itemList.map(
        (
          item: {
            extSellPrice: number;
            itemID: string | number;
            itemDesc: string;
            itemColour: string;
            itemSize: string;
          },
          index: React.Key | null | undefined,
        ) => {
          console.log('item is ', item);
          return (
            <div className="p-2 font-roboto" key={index}>
              <div className="flex justify-between bg-white mb-0.5">
                <div className="text-base font-medium">Max fashion</div>
                <div>
                  <span className="flex ml-1">
                    {<img src={RupeesIcon} height="8" width="8" />}{' '}
                    <span className="text-xss ml-1">
                      {item.extSellPrice.toFixed(2)}
                    </span>
                  </span>
                </div>
              </div>
              <div className="flex justify-between mb-2">
                <div className="text-small text-left w-3/6">
                  {item.itemDesc}
                </div>
                <div className="flex flex-col text-tiny">
                  <div>
                    <span>Color: {item.itemColour}</span>
                    <span className="ml-2">Size: {item.itemSize}</span>
                  </div>
                  <span className="text-right">Qty: 1</span>
                </div>
              </div>
              <div className="border-solid border-gray-300 border-1 mb-2.5"></div>
            </div>
          );
        },
      )
    );
  }

  function renderPriceDetailCard() {
    let totalMRP = 0;
    let promoDiscountAmount = 0;
    let bagPrice = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        totalMRP += item.sellPrice;
        promoDiscountAmount += item.promoDiscountAmount;
      });
    if (orderResp && orderResp.carryBagItem) {
      bagPrice = BAG_PRICE * orderResp.carryBagItem.quantity;
    }
    let couponDiscount = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        if (item.couponDiscountAmount) {
          couponDiscount += item.couponDiscountAmount;
        }
      });
    // let freeBiePrice = 0;
    // if (orderResp && orderResp.selectedFreeBie) {
    //   freeBiePrice += orderResp.selectedFreeBie.extSellPrice;
    // }
    let lmrRewardsPrice = 0;
    if (lmrChecked) {
      lmrRewardsPrice = customerProfileData.pointsAvailable;
    } else {
      lmrRewardsPrice = 0;
    }

    let totalAmount =
      orderResp && orderResp.itemList
        ? orderResp.itemList.reduce((prevAmount, item) => {
            return prevAmount + item.extSellPrice;
          }, 0)
        : 0;
    totalAmount = totalAmount + bagPrice - lmrRewardsPrice;

    return (
      <div className="p-4 font-roboto">
        <div className="flex justify-between bg-white backdrop-blur mb-2 font-medium rounded-radius10">
          <div className=" text-xxs font-medium text-black text-opacity-50">
            Price details
            <span className="text-xss">
              {' '}
              ({orderResp && orderResp.itemList.length}{' '}
              {orderResp &&
              orderResp.itemList &&
              orderResp.itemList.length &&
              orderResp.itemList.length > 1
                ? 'items'
                : 'item'}
              )
            </span>
          </div>
        </div>
        <div className="flex font-roboto justify-between mb-2">
          <div className="text-small">Total MRP</div>
          <div className="text-small flex items-center">
            <img src={RupeesIcon} style={{height: '10px', width: '10px'}} />
            <span className="ml-1">{totalMRP.toFixed(2)}</span>
          </div>
        </div>
        {promoDiscountAmount > 0 && (
          <div className="flex justify-between mb-2">
            <div className="text-small">Additional discount</div>

            <div className="text-small flex items-center">
              <span className="mr-1">–</span>
              <img src={RupeesIcon} style={{height: '10px', width: '10px'}} />
              <span className="ml-1">{promoDiscountAmount.toFixed(2)}</span>
            </div>
          </div>
        )}
        {couponDiscount > 0 && (
          <div className="flex justify-between mb-2 text-royal_blue">
            <div className="text-small">Coupon discount</div>

            <div className="text-small flex items-center">
              <span className="mr-1">–</span>
              <img
                src={RupeesIconBlue}
                style={{height: '10px', width: '10px'}}
              />
              <span className="ml-1">{couponDiscount.toFixed(2)}</span>
            </div>
          </div>
        )}
        {bagPrice > 0 && (
          <div className="flex justify-between mb-2">
            <div className="text-small">Bag</div>

            <div className="text-small flex items-center">
              <img src={RupeesIcon} style={{height: '10px', width: '10px'}} />
              <span className="ml-1">{bagPrice.toFixed(2)}</span>
            </div>
          </div>
        )}
        <div className="border-solid border-gray-300 border-1 mb-2.5"></div>
        <div className="flex justify-between bg-white backdrop-blur mb-2 text-base font-medium">
          <div className="">Total amount paid</div>
          <div className="flex items-center">
            <img src={RupeesIcon} />
            <span className="ml-1">{totalAmount.toFixed(2)}</span>
          </div>
        </div>

        {
          orderResp.isFailed && (
            <div className="text-xxs mt-20">
              We have not yet recieved your payment. Please contact your bank for any queries. If money has been deducted from your account, your bank will inform us within 48 hrs and we will refund the same.
            </div>
          )
        }
      </div>
    );
  }

  if (orderResp === null) {
    return <div></div>;
  } else {
    return (
      <div>
        {type === 'product' ? renderOrderCard() : renderPriceDetailCard()}
      </div>
    );
  }
};
export default OrderCard;
